import { newId } from "../model/surfDeck.js";
const OUTLINE_ROLES = new Set([
    "cover",
    "agenda",
    "content",
    "section",
    "comparison",
    "data",
    "quote",
    "summary",
    "cta",
]);
export function normalizeOutlineRole(raw) {
    const role = String(raw ?? "content")
        .trim()
        .toLowerCase();
    return OUTLINE_ROLES.has(role) ? role : "content";
}
export function newOutlineSection(partial) {
    const role = partial?.role ? normalizeOutlineRole(partial.role) : "content";
    return {
        id: newId(),
        role,
        title: partial?.title?.trim() ?? "",
        subtitle: partial?.subtitle?.trim() || undefined,
        bullets: partial?.bullets?.map((b) => b.trim()).filter(Boolean) ?? [],
        body: partial?.body?.trim() || undefined,
        notes: partial?.notes?.trim() || undefined,
        visual: partial?.visual,
        layoutHint: partial?.layoutHint?.trim() || undefined,
        intent: partial?.intent?.trim() || role,
    };
}
/** Testo slide per prompt immagine contestuale (title + subtitle + bullets). */
export function sectionTextSubject(section) {
    const parts = [
        section.visual?.imageSubject,
        section.title,
        section.subtitle,
        ...section.bullets,
        section.body,
    ]
        .filter((s) => Boolean(s?.trim()))
        .map((s) => s.trim());
    return parts.join(". ").slice(0, 600) || "abstract concept";
}
